
<app-breadcrumb [title]="'Particular'" [items]="['Vehiculos']" [active_item]="'Particular'"></app-breadcrumb>
<div class="container-fluid">
<div class="card">
 <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-school-bus me-2"></i>
      <h5 class="mb-0"><strong>LISTADO DE VEHÍCULOS PARTICULARES</strong></h5>
    </div>
  <div class="card-body custom-datatable noscroll">
    <div class="row mb-12">
      <div class="col-sm-12 col-md-3 ms-auto"> 
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar....."
            [(ngModel)]="searchText"
            (input)="filterData()"
          />
          <span class="input-group-text">
            <i class="fa fa-search"></i> <!-- Icono de búsqueda -->
          </span>
        </div>
      </div>
    </div>
    
    
    <div class="custom-datatable table-responsive">
      <table class="table table-hover table-bordered mt-4" id="tblAfiliadosActivos">
          <thead class="bg-primary">
          <tr>
            <th class="text-center"  style="cursor: pointer;"><strong>PLACA</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>INT.</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>MARCA</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>MODELO</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>CLASE</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>CC PROPIETARIO</strong></th>
            <th class="text-center"  style="cursor: pointer;"><strong>PROPIETARIO</strong></th>
           <!--  <th class="text-center" >SUCURSAL</th> -->
            <th class="text-center" ><strong>RELACIÓN</strong></th>
            <th class="text-center px-3" ><strong>SOAT</strong></th>
            <!-- <th class="text-center" ># SOAT</th> -->
            <th class="text-center" style="width: 150px;"><strong>CDA</strong></th>
            <!-- <th class="text-center" ># CDA</th> -->
            <th class="text-center" ><strong>OPCIONES</strong></th>

          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let vehicle of vehicles of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }">
            <td class="text-center">{{ vehicle.placa }}</td>
            <td class="text-center">{{ vehicle.interno }}</td>
            <td class="text-center">{{ vehicle.marcas?.marca }}</td>
            <td class="text-center">{{ vehicle.modelo }}</td>
            <td class="text-center">{{ vehicle.tipoVehiculo?.tipos }}</td>
            <td class="text-center">{{ vehicle.Idpropietario }}</td>
            <td class="text-uppercase text-justify">
              {{ vehicle.propietario?.primernombre }} 
              {{ vehicle.propietario?.segundonombre }}
              {{ vehicle.propietario?.papellidos }}
              {{ vehicle.propietario?.seapellidos }}</td>
           <!--  <td class="text-center">{{ vehicle.sucursal }}</td> -->
            <td class="text-center">{{ vehicle.tipoRelacion?.relacion  }}</td>

            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialSoat?.[0]?.estadoCalculado.estado)">
                {{ vehicle.historialSoat?.[0]?.vencimiento_soat  | date:'dd/MM/yyyy' || 'Sin fecha' }}
              </span>
            </td>
            <!-- <td class="text-center">{{ vehicle.historialSoat?.[0]?.id_soat }}</td> -->
            <td class="text-center">
              <span class="badge" [ngClass]="getEstadoColor(vehicle.historialCda?.[0]?.estadoCalculado.estado)">
                {{ vehicle.historialCda?.[0]?.vcda | date:'dd/MM/yyyy' || 'Sin fecha' }}
              </span>
            </td>
            <!-- <td class="text-center">{{ vehicle.historialCda?.[0]?.idcda }}</td> -->
            <!-- Buscar tarjeta correspondiente -->
            <td>
              <div class="action text-center">
                <ul class="list-inline d-flex justify-content-center gap-3">
                  <li class="list-inline-item edit">
                    <a href="javascript:void(0)">
                      <i class="icon-pencil-alt" (click)="editarVehiculo(vehicle.placa)" ngbTooltip="Editar" *ngIf="auth.hasPermiso('vehiculos.editar')"></i>
                    </a>
                  </li>
                  <li class="list-inline-item delete">
                    <a href="javascript:void(0)">
                      <i class="icon-trash" (click)="avisoInactivarVehiculo(vehicle.placa)" ngbTooltip="Inactivar" *ngIf="auth.hasPermiso('vehiculos.inactivar')"></i>
                    </a>
                  </li>
                               <li class="list-inline-item">
              <div ngbDropdown container="body" class="digital-dropdown">
                <button type="button" class="btn btn-primary digital-toggle" ngbDropdownToggle>
                  Digitales
                </button>

                <div ngbDropdownMenu class="digital-menu">
                  <button type="button" ngbDropdownItem (click)="cargarDocumentos(vehicle.placa, vehicle.servicio)">
                    <i class="fa fa-upload me-2"></i>
                    Cargar Documentos
                  </button>

                  <button type="button" ngbDropdownItem (click)="ExportarFichaCalidad(vehicle.placa, vehicle.servicio)">
                    <i class="fa fa-file-text-o me-2"></i>
                    Hoja de Vida Vehículo
                  </button>

                  <button type="button" ngbDropdownItem (click)="ExportarFichaFotografica(vehicle.placa, vehicle.servicio)">
                    <i class="fa fa-camera me-2"></i>
                    Ficha Fotográfica
                  </button>
                </div>
              </div>
            </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>



    </div>
     <div class="row align-items-center mt-4 g-2">
    <!-- Selector de registros por página -->
    <div class="col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-start">
      <label for="pageSize1" class="me-2 mb-0">Mostrar:</label>
      <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
        <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
      </select>
      <span class="ms-2">registros por página</span>
    </div>

    <!-- Total de registros -->
    <div class="col-12 col-md-4 text-center my-2 my-md-0">
      <span class="badge bg-primary ms-1"><b><span>Total Registros: </span>{{ vehicles.length || 0 }}</b></span>
    </div>

    <!-- Paginador -->
    <div class="col-12 col-md-4 text-center text-md-end">
      <pagination-controls 
        (pageChange)="page1 = $event" 
        [maxSize]="5"
        [directionLinks]="true"
        [autoHide]="true"
        previousLabel="Anterior" 
        nextLabel="Siguiente">
      </pagination-controls>
    </div>

    </div>
    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
          (click)="exportarExcel('tblAfiliadosActivos', 'Listado_Afiliados_Activos')">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>

        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
            exportToPDF(
              'tblAfiliadosActivos',
              'Listado_Afiliados_Activos',
              'Listado de Afiliados Activos'
            )
          ">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>

        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Crear"
        (click)="CrearVehiculo()">
        <i class="icofont icofont-plus"></i> Crear
      </button>
      </div>
    </div>
  </div>
    <div
  class="toast-container position-fixed bottom-0 end-0 p-3"
  style="z-index: 1055"
  aria-live="polite"
  aria-atomic="true"
>
  <div
    *ngIf="mostrandoToast"
    class="toast show align-items-center text-white bg-primary border-0"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div class="d-flex">
      <div class="toast-body">
        <div class="spinner-border spinner-border-sm me-2" role="status"></div>
        Generando Documento...
      </div>
    </div>
  </div>
</div>
</div>













  